<template>
	<div style="margin-top: -1rem;">
		<div class="actDiv">
			<label style="margin-left:0.5rem ;">小区</label>
			<a-select  style="width:24rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="theNeighbor" placeholder="可多选" label-in-value
						    option-filter-prop="children"  :filter-option="filterOption" show-search  mode="multiple">
				<a-select-option v-for="(item,index) in neighborList" :key="item.pId" :value="item.pId">{{item.neighborName}}</a-select-option>
			</a-select>
			<label style="margin-left:0.5rem ;">筛选条件</label>
			<a-select   style="width:10rem; margin: 0 0.625rem;font-size: 0.6875rem;"  placeholder="请选择"
						v-model="type"   allowClear>
				<a-select-option v-for="(item,index) in failStrList" :key="item.index" :value="item.index">{{item.name}}
				</a-select-option>
			</a-select>
			<a-checkbox  @change="lihuCheck" style="font-size: 0.65rem;margin-left: 0.3rem;" v-if="false">
							 只看立户表
			</a-checkbox>
			<a-button type="primary"  size="small"  @click="doQuery()" icon="search">查询</a-button>
			<a-button type="primary"  size="small" style="margin: 0 0.625rem" :disabled ="list.length==0" @click="exportData" :loading="exportLoading">导出数据</a-button>
			<a-button type="danger" :loading="chosedSubmitFlag"  size="small" :disabled="canFailed"  @click="readMeter4Failed()">异常补抄</a-button>
			<a-input-search v-model ="theBookNum" placeholder="根据册本号查询"   allowClear  v-if="check4Wh"
			enter-button @search="queryDataByBookNum"  style="width: 12rem; margin-left: 0.625rem;"/>
		</div>
		<vxe-table  align="center" :data="list"  border max-height="600"   ref="mTable"
						  resizable highlight-hover-row :loading="loading"   size="mini" :cell-style="cellClassName">
				<vxe-table-column type="seq" width="50"></vxe-table-column>
				<vxe-table-column title="小区名称" field="NeighborID" width="110"  :formatter="getTheNeighborName"></vxe-table-column>
				<vxe-table-column title="册本号" field="BookNum" width="85" v-if="check4Wh"></vxe-table-column>
				<vxe-table-column title="用户号" field="customerNum" width="85"></vxe-table-column>
				<vxe-table-column title="立户" field="Lihu" width="75" :formatter="getLiHuStatus"></vxe-table-column>
				<vxe-table-column title="给水号" field="APID" width="100" ></vxe-table-column>
				<vxe-table-column title="集中器" field="GPRSAddr"></vxe-table-column>
				<vxe-table-column title="表地址" field="MeterAddr"></vxe-table-column>
				<vxe-table-column title="上次抄表时间" field="ActionTime"  :formatter="getTimeFormatter" width="160"></vxe-table-column>
				<vxe-table-column title="本次抄表时间" field="readtime" :formatter="getTimeFormatter"  width="160"></vxe-table-column>
				<vxe-table-column title="上次抄表读数" field="ActionResult" width="90"></vxe-table-column>
				<vxe-table-column title="本次抄表读数" field="readdata" width="90"></vxe-table-column>
				<vxe-table-column title="用水量" field="waterCount"  width="80" sortable></vxe-table-column>
				<vxe-table-column title="抄表结果分析" field="analyseResult" :title-help="{icon:'vxe-icon--question',message:'读数异常： 本次抄表读数小于0\n用水量异常： 本次读数小于上次读数\n用水量为0： 本次读数等于上次读数\n用水量超阈值： 用水量超过设置的阈值\n用水量远大于平均值： 用水量超过过去6个月平均用水量的2倍'}"></vxe-table-column>
				<vxe-table-column title="操作" field="MID" width="150">
					<template #default="{ row }">
						<a-button   size="small"  type="link"  @click="showHistoryData(row)">历史数据</a-button>
						<a-button   size="small"  type="link"  @click="readOneMeter(row)">抄表</a-button>
					</template>
				</vxe-table-column>
		</vxe-table>
		<a-drawer title="历史读数"  :visible="recentHistoryFlag" width="520" @close="recentHistoryClose" :destroyOnClose="true"  :maskClosable="true">
			<MeterReadHistory  :theId="theShowData.PID"/>
		</a-drawer>
	</div>
</template>

<script>
	import MeterReadHistory from '/src/components/MeterReadHistory.vue'
	export default{
		components:{
			MeterReadHistory,
		},
		data(){
			return{
				chosedSubmitFlag:false,
				canFailed:true,
				theNeighbor:undefined,
				neighborList:[],
				loading:false,
				list:[],
				recentHistoryFlag:false,
				theShowData:{},
				exportLoading:false,
				failOnly:false,
				lihuOnly:false,
				type:'7',
				theBookNum:null,
			}
		},
		methods:{
			queryDataByBookNum(){
				if(this.theBookNum == null || this.theBookNum.length == 0){
					return;
				}
				let param = {
					bookNum:this.theBookNum,
					type:this.type,
				};
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.READ_METER_RESULT_ANALYSE_BOOKNUM_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let msg = data.data.message;
					let result = data.data.result;
					if(code == this.Api.HTTP_OK_CODE){
						this.list = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			readMeter4Failed(){
				if(this.list.length == 0){
					return;
				}
				if(this.list.length>100){
					this.$message.error('异常表补抄一次不能超过100块');
					return;
				}
				this.chosedSubmitFlag = true;
				let a = [];
				for(var i=0;i<this.list.length;i++){
					let item = this.list[i];
					a.push(item.PID);
				}
				let meterIds = a.join(',');
				let url = this.Api.getLastUrl(this.Api.READ_METER_4_CHOSED_URL);
				let param = {meterIds:meterIds};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.chosedSubmitFlag = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success(msg);
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.chosedSubmitFlag = false;
					console.log(error);
				});
			},
			getTheNeighborName({cellValue}){
				let result = '';
				for(var i =0 ;i<this.neighborList.length;i++){
					let item = this.neighborList[i];
					if(cellValue == item.pId){
						result = item.neighborName;
						break;
					}
				}
				return result;
			},
			readOneMeter(row){
				let url = this.Api.getLastUrl(this.Api.READ_METER_4_SINGLE_URL);
				let param = {meterId:row.PID};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success(msg);
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			failChangeHandler:function(){
				if(this.theNeighbor == undefined){
					return;
				}
				if(this.failStr!=undefined){
					let array = [];
					for(var i = 0;i<this.dataList.length;i++){
						let item = this.dataList[i];
						if(item.analyseFlag == '0' && item.analyseResult == this.failStr){
							array.push(item);
						}
					}
					this.list = array;
				}else{
					this.list= this.getFailData();
				}
			},
			cellClassName({ row, rowIndex, column }){
				let style = null;
				if(column.property == 'analyseResult'){
					if(row.analyseFlag == '0'){
						style = {
								backgroundColor: '#ffee00',
								color: '#ff0000'
						}
					}
				}
				return style;
			},
			recentHistoryClose:function(){
				this.recentHistoryFlag = false;
			},
			scrollSome:function(){
				this.$refs.mTable.refreshScroll();
			},
			queryNeighbors:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			getParam(){
				var neighborIds = '';
				if(this.theNeighbor != undefined && this.theNeighbor != null ){
					var neighborList = [];
					for(var i =0 ;i<this.theNeighbor.length;i++){
						let item = this.theNeighbor[i];
						neighborList.push(item.key);
					}
					neighborIds = neighborList.join(',');
				}
				let param = {
					neighborIds:neighborIds,
					type:this.type,
				};
				return param;
			},
			doQuery(){
				let param = this.getParam();
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.READ_METER_RESULT_ANALYSE_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.list = result;
					}else{
						this.$message.error(msg);
					}
					if(this.type == '5' && this.list.length>0){
						this.canFailed = false;
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			reloadData:function(){
				if(this.theNeighbor){
					this.queryData();
				}else{
					this.$message.error('请选择小区');
				}
			},
			exportData:function(){
				this.exportLoading = true;
				let url = null;
				let param = null;
				if(this.theBookNum !=null && this.theBookNum.length>0){
					url = this.Api.getLastUrl(this.Api.READ_METER_RESULT_ANALYSE_EXPORT_BOOKNUM_URL);
					param = {bookNum:this.theBookNum,type:this.type};
				}else{
					url = this.Api.getLastUrl(this.Api.READ_METER_RESULT_ANALYSE_EXPORT_URL);
					param = this.getParam();
				}
				this.Api.fetchPostFile(url,param).then((res)=>{
					this.exportLoading = false;
					let blob = new Blob([res.data]);
					let downloadElement = document.createElement('a')
					let href = window.URL.createObjectURL(blob); //创建下载的链接
					downloadElement.href = href;
					let fileName = '抄表结果分析.xlsx';
					downloadElement.download = fileName; //下载后文件名
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放blob对象
				}).catch((error)=>{
					this.exportLoading = false;
					console.log(error);
				});
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
			getMeterState({cellValue}){
				return this.Config.getValueByNameFromList(cellValue,this.Config.getMeterStateList());
			},
			getLiHuStatus({cellValue}){
				return this.Config.getValueByNameFromList(cellValue,this.Config.getLiHUList());
			},
			getTimeFormatter({cellValue}){
				if(cellValue == null){
					return "";
				}else{
					let date = new Date(cellValue);
					return this.Config.formatDate(date);
				}
			},
			showHistoryData:function(record){
				this.theShowData = record;
				this.recentHistoryFlag = true;
			},
			failDataCheck:function(e){
				this.failOnly = e.target.checked;
				this.showCheckData();
			},
			lihuCheck:function(e){
				this.lihuOnly = e.target.checked;
				this.showCheckData();
			},
			showCheckData:function(){
				this.list = [];
				if(this.failOnly && this.lihuOnly){
					let l = this.getLihuData();
					let f = this.getFailData();
					let lSet = new Set(l);
					let fSet = new Set(f);
					this.list = Array.from(new Set(f.filter(v=>lSet.has(v))));
				}else if(this.failOnly && !this.lihuOnly){
					this.list= this.getFailData();
				}else if(!this.failOnly && this.lihuOnly){
					this.list= this.getLihuData();
				}else{
					this.list = this.dataList;
				}
			},
			getFailData:function(){
				let  temp = [];
				for(var  i=0;i<this.dataList.length;i++){
					let item = this.dataList[i];
					if(item.analyseFlag == '0'){
						temp.push(item);
					}
				}
				return temp;
			},
			getLihuData:function(){
				let  temp = [];
				for(var  i=0;i<this.dataList.length;i++){
					let item = this.dataList[i];
					if(item.Lihu == '1'){
						temp.push(item);
					}
				}
				return temp;
			},
		},
		created() {
			this.queryNeighbors();
		},
		computed:{
			failStrList:function(){
				var array = new Array();
				let obj1 = {
					name:"读数异常",
					index:'1'
				}
				array.push(obj1);
				let obj2 = {
					name:"用水量异常",
					index:'2'
				}
				array.push(obj2);
				let obj3 = {
					name:"用水量超过阈值",
					index:'3'
				}
				array.push(obj3);
				let obj4 = {
					name:"用水量远大于平均值",
					index:'4'
				}
				//array.push(obj4);
				let obj5 = {
					name:"全部异常数据",
					index:'5'
				}
				array.push(obj5);
				let obj6 = {
					name:"全部正常数据",
					index:'6'
				}
				array.push(obj6);
				let obj7 = {
					name:"全部数据",
					index:'7'
				}
				array.push(obj7);
				return array;
			},
			check4Wh:function(){
				let user = this.Config.getUserLocal();
				if(user.wcId == 37){
					return true;
				}else{
					return false;
				}
			},
		}
	}
</script>

<style>
</style>
